(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-statistic', {
            parent: 'entity',
            url: '/handbook-statistic?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookStatistic.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistics.html',
                    controller: 'HandbookStatisticController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookStatistic');
                    $translatePartialLoader.addPart('handbookStatisticType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-statistic-detail', {
            parent: 'handbook-statistic',
            url: '/handbook-statistic/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookStatistic.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-detail.html',
                    controller: 'HandbookStatisticDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookStatistic');
                    $translatePartialLoader.addPart('handbookStatisticType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookStatistic', function($stateParams, HandbookStatistic) {
                    return HandbookStatistic.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-statistic',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-statistic-detail.edit', {
            parent: 'handbook-statistic-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-statistic.new', {
            parent: 'handbook-statistic',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('handbook-statistic');
                });
            }]
        })
        .state('handbook-statistic.edit', {
            parent: 'handbook-statistic',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-statistic.delete', {
            parent: 'handbook-statistic',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-delete-dialog.html',
                    controller: 'HandbookStatisticDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
